module.exports = __webpack_public_path__ + "static/app-editor-aea110814645d39e547f6feb1c2fe010.png";